import { HEALTH_APP_RESULTS } from "pages/PreQualification/utils/constants";
import FooterButton from "uicomponents/FooterButton";
import DeniedHIContent from "./DeniedHIContent";
import { getAppType, getCWRedirectUrl } from "utils/helper";
import styles from "./Results.module.css";
import { sendCustomerIOEvent } from "utils/analytics/customerio";
import { getMemberUuid } from "utils/idHelpers";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";

const ResultPageDeniedModel = (): JSX.Element => {
  const { authState } = useOktaAuth();
  const accessToken = authState?.accessToken?.accessToken;
  const appType = getAppType();

  useEffect(() => {
    sendCustomerIOEvent(
      {
        event_name: "health_insurance_application_disqualified",
        event_type: "health_app_stages",
        member_uuid: getMemberUuid(),
        data: {
          health_app_status: "HI_DISQUALIFIED",
          app_name: appType,
          version: 1, // TODO: use flowVersion
        },
      },
      accessToken || ""
    );
  }, [accessToken, appType]);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{HEALTH_APP_RESULTS.DENIED.title}</h3>
      <DeniedHIContent />
      <FooterButton
        nextButtonText={HEALTH_APP_RESULTS.DENIED.nextButtonText}
        nextButtonHref={getCWRedirectUrl("/onboarding_checklist")}
        hasOnlyNextButton
      />
    </div>
  );
};

export default ResultPageDeniedModel;
